import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        form: '=',
        tab: '=',
        context: '='
    },
    template: `
        <loader-icon ng-if="vm.saving" overlay="true"></loader-icon>
        <ul class="actions01" ng-if="!vm.saving">
            <li class="primary" ng-if="vm.canManagePlanningGroups">
                <a class="btn main" ng-click="vm.startGroup()" ng-if="vm.showSaveAndStart()">{{ 'planningGroup.Save and start group' | translate }}</a>
                <a class="btn main" ng-click="vm.startGroup()" ng-if="vm.showStart()">{{ 'planningGroup.Start group' | translate }}</a>
            </li>
            <li class="primary" ng-if="vm.canManagePlanningGroups">
                <a class="btn negative" ng-click="vm.stopGroup()" ng-if="vm.showStop()">{{ 'planningGroup.Stop group' | translate }}</a>
            </li>
            <li class="primary" ng-if="vm.canManagePlanningGroups">
                <a ng-click="vm.save()" class="btn bordered02" ng-if="vm.showSave()">{{ 'general.Save' | translate }}</a>
                <a ng-click="vm.save()" class="btn main" ng-if="vm.showNext()">{{ 'general.Next' | translate }}</a>
                <a ng-click="vm.save(true)" class="btn bordered02" ng-if="vm.showFinish()">{{ 'general.Finish' | translate }}</a>
            </li>
            <li>
                <a ui-sref="authorized.courses.courses.edit.occurrence.list()" class="btn discrete">
                    <span ng-if="vm.planningGroup.id">{{ 'general.Back to list' | translate }}</span>
                    <span ng-if="!vm.planningGroup.id">{{ 'general.Cancel' | translate }}</span>
                </a>
            </li>
        </ul>
    `
})
export default class {
    constructor ($translate, $state, $scope, $window, $q, lodash, toastr,
                 UserResource, CourseVersionResource,
                 ModalService, PrivilegeService, CourseVersionService,
                 AUTOMATED_PLANNING_GROUP_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_TYPE_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.$state = $state;
        this.$scope = $scope;
        this.$window = $window;
        this.$q = $q;
        this.lodash = lodash;
        this.UserResource = UserResource;
        this.CourseVersionResource = CourseVersionResource;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionService = CourseVersionService;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
    }

    $onInit () {
        this.canManagePlanningGroups = this.PrivilegeService.canManageAutomatedPlanningGroups();
        this.oldSiteIds = Array.isArray(this.planningGroup.siteIds) ? this.planningGroup.siteIds.map(String) : [];
        this.isAdd = this.context === 'add';
        this.isEdit = this.context === 'edit';
        this.isGeneralTab = this.tab === 'general';
        this.isTargetsTab = this.tab === 'targets';
        this.isEmployeeTab = this.tab === 'employee';
        this.isManual = this.planningGroup.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.MANUAL;
        this.isAutomatic = this.planningGroup.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC;
        this.isNotStarted = this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.NOT_STARTED;
        this.isStarted = this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED;
        this.isStopped = this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STOPPED;
        this.isCancelled = this.planningGroup.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED;
    }

    /**
     * The state that resolves the planning group the three tabs are rendered from
     * @returns {string}
     */
    get PLANNING_GROUP_STATE () {
        return 'authorized.courses.courses.edit.occurrence.automated.edit';
    }

    startGroup () {
        const messages = [];

        this.CourseVersionResource.get({ id: this.form.model.courseVersionId, expand: 'courseTrainings' })
            .$promise
            .then((version) => {
                if (!this.CourseVersionService.hasRequiredTrainings(version.courseTrainings)) {
                    messages.push(this.$translate.instant('version.only_online_trainings_message'));
                }
                messages.push(this.getGenericConfirm(true));
                this.ModalService.confirm(messages, 'medium').then(() => {
                    this.form.model.status = this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.STARTED;
                    this.save();
                });
            });
    }

    stopGroup () {
        const { planningGroup } = this;
        this.ModalService.open({
            size: 'large',
            template: `
                <modals-courses-occurrence-automated-planning-group-status
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    planning-group="vm.planningGroup"
                />`,
            controller ($uibModalInstance) {
                this.planningGroup = planningGroup;
                this.$uibModalInstance = $uibModalInstance;
            }
        }).then(model => this.handleSuccess(model, false));
    }

    save (isFinish = false) {
        this.handleConfirms(isFinish)
            .then(() => this.form.save()
                .then(model => this.handleSuccess(model, isFinish))
                .catch(() => this.handleError())
            )
            .catch(() => {
                this.saving = false;
            });
    }

    handleConfirms (isFinish) {
        const deferred = this.$q.defer();
        const messages = [];

        if (isFinish) {
            deferred.resolve();
        }
        else {
            const siteConfirm = this.getSiteConfirm();
            if (siteConfirm) {
                messages.push(siteConfirm);
            }

            const genericConfirm = this.getGenericConfirm();
            if (genericConfirm) {
                messages.push(genericConfirm);
            }

            // the site select drops the site the moment it is unchecked, long before this prompt, so a
            // no has to put the selection back or the group reads as if it lost the site anyway
            const rejectSave = () => {
                if (siteConfirm) {
                    this.$scope.$emit('planning-group:restore-sites');
                }
                deferred.reject();
            };

            // if no users or not all sites selected or excluded is not checked --> no notification
            const hasSiteIds = Array.isArray(this.form.model.siteIds) && this.form.model.siteIds.length > 0;
            if (this.planningGroup.planningGroupUsers.length && !hasSiteIds && this.form.model.excludeExternalSites) {
                // loading every member takes seconds in a large group, the loader shows it is working
                this.saving = true;
                this.UserResource.query({ planningGroupId: this.planningGroup.id, expand: 'employeeRoleSites' })
                    .$promise
                    .then((users) => {
                        const onlyExternalSiteUsers = users.filter((user) => this.hasOnlyExternalSiteEmployees(user.employeeRoleSites));

                        if (onlyExternalSiteUsers.length) {
                            messages.push(this.$translate.instant('planningGroup.only_external_remove_message'));
                        }
                        this.ModalService.confirm(messages, 'medium')
                            .then(() => {
                                this.saving = true;
                                deferred.resolve();
                            })
                            .catch(rejectSave)
                        ;
                    });
            }
            else {
                this.ModalService.confirm(messages, 'medium')
                    .then(() => {
                        this.saving = true;
                        deferred.resolve();
                    })
                    .catch(rejectSave)
                ;
            }
        }

        return deferred.promise;
    }

    getGenericConfirm (startGroup = false) {
        let message = false;
        const wasAutomatic = this.isAutomatic;
        const wasManual = this.isManual;
        const isAutomatic = this.form.model.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC;
        const isManual = this.form.model.type === this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.MANUAL;

        if (startGroup) {
            if (wasManual && isAutomatic) {
                message = this.$translate.instant('planningGroup.confirm_save_and_start_apg_with_type_change_automatic');
            }
            else {
                message = this.$translate.instant('planningGroup.confirm_save_and_start_apg');
            }
        }
        else {
            if (isAutomatic && this.isAdd && this.isGeneralTab) {
                message = this.$translate.instant('planningGroup.confirm_add_apg_with_type_automatic');
            }
            else if (wasAutomatic && isManual) {
                message = this.$translate.instant('planningGroup.confirm_save_apg_type_change_manual');
            }
            else if (wasManual && isAutomatic) {
                message = this.$translate.instant('planningGroup.confirm_save_apg_type_change_automatic');
            }
        }

        return message;
    }

    getSiteConfirm () {
        const currentSiteIds = Array.isArray(this.form.model.siteIds) ? this.form.model.siteIds.map(String).sort() : [];
        const siteIdsUnchanged = JSON.stringify(this.oldSiteIds.sort()) === JSON.stringify(currentSiteIds);
        if (siteIdsUnchanged || !currentSiteIds.length || this.planningGroup.planningGroupUsers.length === 0) {
            return false;
        }

        // an empty previous list means the group covered every site, so naming specific ones narrows it
        const narrowedFromAllSites = !this.oldSiteIds.length;
        // a count that stays the same still loses a site when one is swapped for another, so ask which
        // sites went away rather than how many are left
        const removedSomeSites = this.oldSiteIds.some(siteId => currentSiteIds.indexOf(siteId) === -1);

        if (!narrowedFromAllSites && !removedSomeSites) {
            return false;
        }

        return this.$translate.instant('planningGroup.change_site_confirm_message');
    }

    hasOnlyExternalSiteEmployees (sites) {
        const otherThanExcludedSite = this.lodash.find(sites, (site) => !site.isExternalSite);

        return !otherThanExcludedSite;
    }

    handleSuccess (model, isFinish) {
        this.saving = false;
        // a toast top right instead of the "Changes saved" bar above the form, also when the add steps move on
        if (this.form.saved) {
            this.toastr.success(this.$translate.instant('general.Changes saved'));
        }
        this.form.saved = false;
        if (Array.isArray(model.siteIds)) {
            model.siteIds = model.siteIds.map(Number);
        }

        this.planningGroup = model;
        this.form.model = angular.copy(model);
        this.form.model.targets = model.planningGroupTargetsWithValue;
        this.$scope.$emit('planning-group:update', model);
        // the add steps move on to another state below, its employee step loads the list itself;
        // reloading it here as well sent the same heavy request twice
        if (!this.isAdd) {
            this.$scope.$emit('employee-list:update');
        }
        if (this.isAdd) {
            if (this.isEmployeeTab) {
                if (isFinish) {
                    // saveErrors is cleared explicitly: parameters a transition does not name are
                    // inherited, and the params object itself is frozen, so this is the only way a
                    // refusal carried to the general tab stops after the save that answered it
                    this.$state.go('^.^.edit.general', {
                        id: this.$state.params.id, planningGroupId: this.planningGroup.id, saveErrors: null
                    });
                }
                else {
                    this.$state.go('^.^.edit.employee', {
                        id: this.$state.params.id, planningGroupId: this.planningGroup.id
                    });
                }
            }
            else {
                if (this.isGeneralTab) {
                    this.$state.go('^.targets', {
                        id: this.$state.params.id, planningGroupId: this.planningGroup.id
                    });
                }
                else {
                    this.$state.go('^.employee', {
                        id: this.$state.params.id, planningGroupId: this.planningGroup.id
                    });
                }
            }
        }
        this.$onInit();
    }

    handleError () {
        this.saving = false;
        this.form.model.status = this.planningGroup.status;
        if (this.$window.document.scrollingElement) {
            this.$window.document.scrollingElement.scrollTop = 0;
        }

        // the overlap rules are about the group's sites and its people, and only the general tab can
        // change either, so a refusal for them anywhere else is taken there together with its message
        if (!this.isGeneralTab && (this.form.errors.status || this.form.errors.siteIds)) {
            this.$state.go(
                this.isEdit ? '^.general' : '^.^.edit.general',
                {
                    id: this.$state.params.id,
                    planningGroupId: this.planningGroup.id,
                    saveErrors: this.form.errors
                },
                // a start refused for an overlap keeps everything except the start, so the group the
                // tabs were resolved with is out of date, the type above all. Moving between siblings
                // does not re-enter their parent, which is where the group is resolved, so ask for it
                { reload: this.PLANNING_GROUP_STATE }
            );
            return;
        }

        // if status error, do not show generic form error because status errors are displayed on top of form
        if (this.form.errors.status) {
            this.form.invalid = false;
        }
    }

    showNext () {
        return this.isAdd && (this.isGeneralTab || this.isTargetsTab);
    }

    showSave () {
        return (this.isAdd && this.isEmployeeTab && this.isManual)
            || (this.isEdit && this.isStarted && this.isTargetsTab)
            || (this.isEdit && this.isStopped && this.isTargetsTab)
            || (this.isEdit && this.isNotStarted && this.isTargetsTab)
            || (this.isEdit && this.isNotStarted && this.isGeneralTab)
            || (this.isEdit && this.isStopped && this.isGeneralTab)
            || (this.isEdit && this.isStarted && this.isGeneralTab)
        ;
    }

    showStart () {
        return (this.isAdd && this.isEmployeeTab && this.isAutomatic)
            || (this.isAdd && this.isNotStarted && this.isAutomatic)
            || (this.isEdit && this.isNotStarted && this.isAutomatic)
        ;
    }

    showSaveAndStart () {
        return (this.isAdd && this.isEmployeeTab && this.isManual)
            || (this.isEdit && this.isStopped)
            || (this.isEdit && this.isNotStarted && this.isManual)
        ;
    }

    showStop () {
        return this.isEdit && this.isStarted;
    }

    showFinish () {
        return this.isAdd && this.isEmployeeTab && this.isAutomatic;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/footer/index.js